"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @since 2019-12-29 10:17
 * @author vivaxy
 */
exports.CHROMATICITIES_DIVISION = 1e5;
